<section>
    <!-- Cabecera -->
    <div class="order-status-header border-b pb-16 pt-16 mb-32" *ngIf="(step$ | async) === OrderStatusStep.FOUND">
        <div (click)="goCheck()" class="is-flex pl-body pr-body content-center pointer">
            <button type="button" class="link-raw iconPrev content-center">
                <i class="icon icon-arrow-prev"></i>
                <span class="ml-8 title-s ttu sm:hidden">{{ 'dev.general.back' | translate }}</span>
            </button>
            <div class="text-l ttu">{{ 'dev.orderStatus.header' | translate }}</div>
        </div>
    </div>
    <div *ngIf="(step$ | async) !== OrderStatusStep.FOUND" class="container-fluid pr-body pl-body pb-32 mtr-128">
        <div class="row align-center">
            <div class="col-xs-12 wmax-550 text-left">
                <order-status-search class="mb-64"></order-status-search>
                <order-status-my-account-btn></order-status-my-account-btn>
            </div>
        </div>
    </div>
    <div *ngIf="(step$ | async) === OrderStatusStep.FOUND" class="container-fluid pr-body pl-body pb-32 pt-16">
        <div class="row">
            <div class="col-xs-12 text-left">
                <order-status-detail></order-status-detail>
            </div>
        </div>
    </div>
</section>
